import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ChatWindow from './components/ChatWindow';
import Index from './components/Index';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Pääsivu */}
        <Route path="/" element={<Index />} />
        {/* Chat-sivu */}
        <Route path="/chat" element={<ChatWindow />} />
      </Routes>
    </Router>
  );
};

export default App;
